// Rune ID to name and path mapping
export const runeIdMapping: Record<number, { key: string; name: string; path?: string }> = {
  // Domination
  8100: { key: "Domination", name: "Domination" },
  8112: { key: "Electrocute", name: "Electrocute", path: 'Styles/Domination/Electrocute/Electrocute.png' },
  8128: { key: "DarkHarvest", name: "Dark Harvest", path: 'Styles/Domination/DarkHarvest/DarkHarvest.png' },
  9923: { key: "HailOfBlades", name: "Hail of Blades", path: 'Styles/Domination/HailOfBlades/HailOfBlades.png' },
  8126: { key: "CheapShot", name: "Cheap Shot", path: 'Styles/Domination/CheapShot/CheapShot.png' },
  8139: { key: "TasteOfBlood", name: "Taste of Blood", path: 'Styles/Domination/TasteOfBlood/GreenTerror_TasteOfBlood.png' },
  8143: { key: "SuddenImpact", name: "Sudden Impact", path: 'Styles/Domination/SuddenImpact/SuddenImpact.png' },
  8137: { key: "SixthSense", name: "Sixth Sense", path: 'Styles/Domination/SixthSense/SixthSense.png' },
  8140: { key: "GrislyMementos", name: "Grisly Mementos", path: 'Styles/Domination/GrislyMementos/GrislyMementos.png' },
  8141: { key: "DeepWard", name: "Deep Ward", path: 'Styles/Domination/DeepWard/DeepWard.png' },
  8135: { key: "TreasureHunter", name: "Treasure Hunter", path: 'Styles/Domination/TreasureHunter/TreasureHunter.png' },
  8105: { key: "RelentlessHunter", name: "Relentless Hunter", path: 'Styles/Domination/RelentlessHunter/RelentlessHunter.png' },
  8106: { key: "UltimateHunter", name: "Ultimate Hunter", path: 'Styles/Domination/UltimateHunter/UltimateHunter.png' },

  // Inspiration
  8300: { key: "Inspiration", name: "Inspiration" },
  8351: { key: "GlacialAugment", name: "Glacial Augment", path: 'Styles/Inspiration/GlacialAugment/GlacialAugment.png' },
  8360: { key: "UnsealedSpellbook", name: "Unsealed Spellbook", path: 'Styles/Inspiration/UnsealedSpellbook/UnsealedSpellbook.png' },
  8369: { key: "FirstStrike", name: "First Strike", path: 'Styles/Inspiration/FirstStrike/FirstStrike.png' },
  8306: { key: "HextechFlashtraption", name: "Hextech Flashtraption", path: 'Styles/Inspiration/HextechFlashtraption/HextechFlashtraption.png' },
  8304: { key: "MagicalFootwear", name: "Magical Footwear", path: 'Styles/Inspiration/MagicalFootwear/MagicalFootwear.png' },
  8321: { key: "CashBack", name: "Cash Back", path: 'Styles/Inspiration/PerfectTiming/PerfectTiming.png' },
  8313: { key: "PerfectTiming", name: "Triple Tonic", path: 'Styles/Inspiration/TimeWarpTonic/TimeWarpTonic.png' },
  8352: { key: "TimeWarpTonic", name: "Time Warp Tonic", path: 'Styles/Inspiration/TimeWarpTonic/TimeWarpTonic.png' },
  8345: { key: "BiscuitDelivery", name: "Biscuit Delivery", path: 'Styles/Inspiration/BiscuitDelivery/BiscuitDelivery.png' },
  8347: { key: "CosmicInsight", name: "Cosmic Insight", path: 'Styles/Inspiration/CosmicInsight/CosmicInsight.png' },
  8410: { key: "ApproachVelocity", name: "Approach Velocity", path: 'Styles/Inspiration/ApproachVelocity/ApproachVelocity.png' },
  8316: { key: "JackOfAllTrades", name: "Jack Of All Trades", path: 'Styles/Inspiration/MinionDematerializer/MinionDematerializer.png' },

  // Precision
  8000: { key: "Precision", name: "Precision" },
  8005: { key: "PressTheAttack", name: "Press the Attack", path: 'Styles/Precision/PressTheAttack/PressTheAttack.png' },
  8008: { key: "LethalTempo", name: "Lethal Tempo", path: 'Styles/Precision/LethalTempo/LethalTempoTemp.png' },
  8021: { key: "FleetFootwork", name: "Fleet Footwork", path: 'Styles/Precision/FleetFootwork/FleetFootwork.png' },
  8010: { key: "Conqueror", name: "Conqueror", path: 'Styles/Precision/Conqueror/Conqueror.png' },
  9101: { key: "AbsorbLife", name: "Absorb Life", path: 'Styles/Precision/AbsorbLife/AbsorbLife.png' },
  9111: { key: "Triumph", name: "Triumph", path: 'Styles/Precision/Triumph.png' },
  8009: { key: "PresenceOfMind", name: "Presence of Mind", path: 'Styles/Precision/PresenceOfMind/PresenceOfMind.png' },
  9104: { key: "LegendAlacrity", name: "Legend: Alacrity", path: 'Styles/Precision/LegendAlacrity/LegendAlacrity.png' },
  9105: { key: "LegendHaste", name: "Legend: Haste", path: 'Styles/Precision/LegendHaste/LegendHaste.png' },
  9103: { key: "LegendBloodline", name: "Legend: Bloodline", path: 'Styles/Precision/LegendBloodline/LegendBloodline.png' },
  8014: { key: "CoupDeGrace", name: "Coup de Grace", path: 'Styles/Precision/CoupDeGrace/CoupDeGrace.png' },
  8017: { key: "CutDown", name: "Cut Down", path: 'Styles/Precision/CutDown/CutDown.png' },
  8299: { key: "LastStand", name: "Last Stand", path: 'styles/sorcery/laststand/laststand.png' },

  // Resolve
  8400: { key: "Resolve", name: "Resolve" },
  8437: { key: "GraspOfTheUndying", name: "Grasp of the Undying", path: 'Styles/Resolve/GraspOfTheUndying/GraspOfTheUndying.png' },
  8439: { key: "Aftershock", name: "Aftershock", path: 'Styles/Resolve/VeteranAftershock/VeteranAftershock.png' },
  8465: { key: "Guardian", name: "Guardian", path: 'Styles/Resolve/Guardian/Guardian.png' },
  8446: { key: "Demolish", name: "Demolish", path: 'Styles/Resolve/Demolish/Demolish.png' },
  8463: { key: "FontOfLife", name: "Font of Life", path: 'Styles/Resolve/FontOfLife/FontOfLife.png' },
  8401: { key: "ShieldBash", name: "Shield Bash", path: 'Styles/Resolve/MirrorShell/MirrorShell.png' },
  8429: { key: "Conditioning", name: "Conditioning", path: 'Styles/Resolve/Conditioning/Conditioning.png' },
  8444: { key: "SecondWind", name: "Second Wind", path: 'Styles/Resolve/SecondWind/SecondWind.png' },
  8473: { key: "BonePlating", name: "Bone Plating", path: 'Styles/Resolve/BonePlating/BonePlating.png' },
  8451: { key: "Overgrowth", name: "Overgrowth", path: 'Styles/Resolve/Overgrowth/Overgrowth.png' },
  8453: { key: "Revitalize", name: "Revitalize", path: 'Styles/Resolve/Revitalize/Revitalize.png' },
  8242: { key: "Unflinching", name: "Unflinching", path: 'Styles/Resolve/Unflinching/Unflinching.png' },

  // Sorcery
  8200: { key: "Sorcery", name: "Sorcery" },
  8214: { key: "SummonAery", name: "Summon Aery", path: 'Styles/Sorcery/SummonAery/SummonAery.png' },
  8229: { key: "ArcaneComet", name: "Arcane Comet", path: 'Styles/Sorcery/ArcaneComet/ArcaneComet.png' },
  8230: { key: "PhaseRush", name: "Phase Rush", path: 'Styles/Sorcery/PhaseRush/PhaseRush.png' },
  8224: { key: "AxiomArcanist", name: "Axiom Arcanist", path: 'Styles/Sorcery/NullifyingOrb/Axiom_Arcanist.png' },
  8226: { key: "ManaflowBand", name: "Manaflow Band", path: 'Styles/Sorcery/ManaflowBand/ManaflowBand.png' },
  8275: { key: "NimbusCloak", name: "Nimbus Cloak", path: 'Styles/Sorcery/NimbusCloak/6361.png' },
  8210: { key: "Transcendence", name: "Transcendence", path: 'Styles/Sorcery/Transcendence/Transcendence.png' },
  8234: { key: "Celerity", name: "Celerity", path: 'Styles/Sorcery/Celerity/CelerityTemp.png' },
  8233: { key: "AbsoluteFocus", name: "Absolute Focus", path: 'Styles/Sorcery/AbsoluteFocus/AbsoluteFocus.png' },
  8237: { key: "Scorch", name: "Scorch", path: 'Styles/Sorcery/Scorch/Scorch.png' },
  8232: { key: "Waterwalking", name: "Waterwalking", path: 'Styles/Sorcery/Waterwalking/Waterwalking.png' },
  8236: { key: "GatheringStorm", name: "Gathering Storm", path: 'Styles/Sorcery/GatheringStorm/GatheringStorm.png' },

  // Stat Shards
  5008: { key: "AdaptiveForce", name: "Adaptive Force" },
  5005: { key: "AttackSpeed", name: "Attack Speed" },
  5007: { key: "AbilityHaste", name: "Ability Haste" },
  5010: { key: "MoveSpeed", name: "Move Speed" },
  5001: { key: "HealthScaling", name: "Health Scaling" },
  5011: { key: "Health", name: "Health" },
  5013: { key: "TenacityAndSlowResist", name: "Tenacity and Slow Resist" }
};

// Map numeric rune tree IDs to lowercase style names (for use with RUNE_TREE_IMAGES)
export const runeIdToStyleName: Record<string, string> = {
  "8100": "domination",
  "8300": "inspiration",
  "8000": "precision", 
  "8400": "resolve",
  "8200": "sorcery"
};

// Mapping from API rune keys to rune names displayed in the UI
export const runeKeyToNameMapping: Record<string, string> = {
  // Domination
  'electrocute': 'Electrocute',
  'darkHarvest': 'Dark Harvest',
  'hailOfBlades': 'Hail of Blades',
  'cheapShot': 'Cheap Shot',
  'tasteOfBlood': 'Taste of Blood',
  'suddenImpact': 'Sudden Impact',
  'zombieWard': 'Zombie Ward',
  'ghostPoro': 'Ghost Poro',
  'eyeballCollection': 'Eyeball Collection',
  'grislyMementos': 'Grisly Mementos',
  'treasureHunter': 'Treasure Hunter',
  'relentlessHunter': 'Relentless Hunter',
  'ultimateHunter': 'Ultimate Hunter',
  'sixthSense': 'Sixth Sense',
  'deepWard': 'Deep Ward',
  
  // Precision
  'pressTheAttack': 'Press the Attack',
  'lethalTempo': 'Lethal Tempo',
  'fleetFootwork': 'Fleet Footwork',
  'conqueror': 'Conqueror',
  'absorbLife': 'Absorb Life',
  'triumph': 'Triumph',
  'presenceOfMind': 'Presence of Mind',
  'legendAlacrity': 'Legend: Alacrity',
  'legendHaste': 'Legend: Haste',
  'legendBloodline': 'Legend: Bloodline',
  'coupdegrace': 'Coup de Grace',
  'cutDown': 'Cut Down',
  'lastStand': 'Last Stand',
  
  // Sorcery
  'summonAery': 'Summon Aery',
  'arcaneComet': 'Arcane Comet',
  'phaseRush': 'Phase Rush',
  'axiomArcanist': 'Axiom Arcanist',
  'manaflowBand': 'Manaflow Band',
  'nimbus': 'Nimbus Cloak',
  'transcendence': 'Transcendence',
  'celerity': 'Celerity',
  'absoluteFocus': 'Absolute Focus',
  'scorch': 'Scorch',
  'waterwalking': 'Waterwalking',
  'gatheringStorm': 'Gathering Storm',
  
  // Resolve
  'graspOfTheUndying': 'Grasp of the Undying',
  'aftershock': 'Aftershock',
  'guardian': 'Guardian',
  'demolish': 'Demolish',
  'fontOfLife': 'Font of Life',
  'shieldBash': 'Shield Bash',
  'conditioning': 'Conditioning',
  'secondWind': 'Second Wind',
  'bonePlating': 'Bone Plating',
  'overgrowth': 'Overgrowth',
  'revitalize': 'Revitalize',
  'unflinching': 'Unflinching',
  
  // Inspiration
  'glacialAugment': 'Glacial Augment',
  'unsealedSpellbook': 'Unsealed Spellbook',
  'firstStrike': 'First Strike',
  'hextechFlashtraption': 'Hextech Flashtraption',
  'magicalFootwear': 'Magical Footwear',
  'perfectTiming': 'Perfect Timing',
  'futuresMarket': "Future's Market",
  'cashBack': 'Cash Back',
  'minionDematerializer': 'Minion Dematerializer',
  'biscuitDelivery': 'Biscuit Delivery',
  'tripleTonic': 'Triple Tonic',
  'cosmicInsight': 'Cosmic Insight',
  'approachVelocity': 'Approach Velocity',
  'timeWarpTonic': 'Time Warp Tonic',
  'jackOfAllTrades': 'Jack of All Trades',
  
  // Stat Shards
  'adaptiveForce': 'Adaptive Force',
  'attackSpeed': 'Attack Speed',
  'abilityHaste': 'Ability Haste',
  'armor': 'Armor',
  'magicResist': 'Magic Resist',
  'healthScaling': 'Scaling Bonus Health',
  'health': 'Bonus Health',
  'moveSpeed': 'Bonus Movement Speed',
  'tenacity': 'Tenacity and Slow Resist'
};

// Export utility functions for runes
export const mapRuneKeyToName = (runeKey: string): string => {
  return runeKeyToNameMapping[runeKey] || runeKey;
};
// Utility functions for getting image URLs
export const getRuneImageUrl = (runeKey: string, runePathMappings: Record<string, string>, runeId?: number): string => {
  // If we have a direct ID mapping, use that first (for selected runes)
  if (runeId && runeIdMapping[runeId]?.path) {
    return `https://ddragon.leagueoflegends.com/cdn/img/perk-images/${runeIdMapping[runeId].path}`;
  }
  
  // Otherwise fall back to the name-based mapping (for unselected runes in the tree)
  const pathSegment = runePathMappings[runeKey];
  if (pathSegment) {
    return pathSegment.startsWith('http') ? pathSegment : `https://ddragon.leagueoflegends.com/cdn/img/perk-images/${pathSegment}`;
  }
  
  // Last resort fallback
  return '';
};

// Parse perk IDs string into array of numbers
export const parsePerkIds = (perkIdsString?: string): number[] => {
  if (!perkIdsString) return [];
  return perkIdsString.split(',').map(Number).filter(id => !isNaN(id));
};

// Find a rune ID by name
export const getRuneIdByName = (name: string): number | undefined => {
  const entry = Object.entries(runeIdMapping).find(
    ([_, info]) => info.name === name
  );
  return entry ? Number(entry[0]) : undefined;
};

// Check if a rune is selected based on its name and a list of rune IDs
export const isRuneSelected = (runeName: string, selectedRuneIds: number[]): boolean => {
  const runeId = getRuneIdByName(runeName);
  if (!runeId) return false;
  return selectedRuneIds.includes(runeId);
}; 